import React from 'react';
import styles from './RangedDropdowns.module.css'

const RangedDropdowns = ({ label, children }) => (
    <div className={` ${styles.Container}`}>
      <div className={styles.Label}>
        {label}
      </div>
      <div className={styles.Children}>
        {children}
      </div>
    </div>
  );

export default RangedDropdowns;